import { HttpClient, HttpEvent, HttpParams, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class UploadService {
  constructor(private http: HttpClient) {}

  // Upload file with timestamped filename
  uploadFile(
    url: string,
    file: File,
    method = "POST"
  ): Observable<any> {
    const data = new FormData();
    
    // Create timestamped filename
    const timestamp = new Date().getTime();
    const fileExtension = file.name.split('.').pop();
    const baseName = file.name.replace(`.${fileExtension}`, '');
    const timestampedFilename = `${baseName}_${timestamp}.${fileExtension}`;
    
    data.append("upload", file, timestampedFilename);

    const options = {
      reportProgress: true,
    };

    return this.http.post(url, data, options);
  }

  // Legacy method for backward compatibility
  upload(
    url: string,
    file: File,
    method = "POST",
    params: any = {}
  ): Observable<any> {
    const data = new FormData();
    data.append("upload", file);

    // Convert params object to HttpParams for query string
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      httpParams = httpParams.set(key, params[key]);
    });

    const options = {
      params: httpParams,
      reportProgress: true,
    };

    return this.http.post(url, data, options);
  }
}
